import http from "../../api/server";
import { UPDATE_ACTION_ITEMS } from "../../api/apiPath";
import Toaster from "./Toaster";
import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CalendarToday } from "@mui/icons-material";
import { forwardRef } from "react";
import dayjs from "dayjs";
function UpdateActionPopUp({
  show,
  headingText,
  cancelText,
  submitText,
  onCancel,
  onSuccess,
  selectedRows,
}) {
  const [popstatus, setPopstatus] = useState("Pending");
  const [comby, setComby] = useState("");
  const [assto, setAssto] = useState("");
  const [isAssignedDisabled, setIsAssignedDisabled] = useState(false);
  const [popcom, setPopcom] = useState("");
  // const [selectedDate, setSelectedDate] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);

  // New state for validation errors
  const [errors, setErrors] = useState({});

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });

  const closeButton = () => {
    setToastData({ toastShow: false, toastData: "", toastType: "" });
  };

  const [loading, setLoading] = useState(false);

  const CalendarInput = forwardRef(({ value, onClick }, ref) => (
    <div className="custom-datepicker-input" onClick={onClick} ref={ref}>
      <input
        type="text"
        value={value}
        readOnly
        className="form-control"
        placeholder="Completed On"
      />
      <CalendarToday style={{ fontSize: 15 }} />
    </div>
  ));

  CalendarInput.displayName = "CalendarInput";
  // Validation Logic
  const validate = () => {
    let tempErrors = {};
    // if (!popstatus) tempErrors.popstatus = "Status is required";
    if (!selectedDate) tempErrors.selectedDate = "Completed On is required";
    if (!comby.trim()) tempErrors.comby = "Completed by is required";
    // if (!assto.trim()) tempErrors.assto = "Assigned To is required";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const updateActionitems = async () => {
    // 1. Check validation before proceeding
    if (!validate()) return;

    try {
      setLoading(true);
      const payload = selectedRows.map((item) => ({
        complianceCheckId: item.compcheckid,
        inspectedDoorId: item.inspdoorid,
        complianceCheckMasterId: item.comcheckmaster,
        status: popstatus,
        completedBy: comby,
        // completedOn: selectedDate,
        completedOn: selectedDate
          ? dayjs(selectedDate).format("YYYY-MM-DD")
          : "",
        ActionItemAssignedTo: assto,
        additionalComments: popcom,
        gaps: item.gaps,
      }));

      const updater = await http.put(UPDATE_ACTION_ITEMS, payload);
      if (updater.status === 200) {
        setToastData({
          toastShow: true,
          toastType: "success",
          toastString: "Action Updated Successfully.",
        });
        // setTimeout(() => onSuccess(), 2000);
        // setTimeout(() => {
        //   onSuccess();
        //   window.location.reload();
        // }, 2000);

        setTimeout(() => {
          onSuccess({
            status: popstatus,
            completedBy: comby,
            completedOn: selectedDate,
            assignedTo: assto,
            comments: popcom,
          });
        }, 2000);
      }
    } catch (err) {
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString: err?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (selectedRows && selectedRows.length > 0) {
      const assignedValue = selectedRows[0].actionItemAssignedTo || "";

      setAssto(assignedValue);
      setIsAssignedDisabled(assignedValue !== "");
    }
  }, [selectedRows]);
  return (
    <div className={show ? "modal-overlay" : "display-none"}>
      <Toaster
        show={toastData.toastShow}
        toastType={toastData.toastType}
        title={toastData.toastString}
        theme={"dark"}
        position="top-center"
        closeButton={closeButton}
      />
      <div className="approval-modal-content p-4" style={{ height: "auto" }}>
        <span className="close" onClick={onCancel}>
          &times;
        </span>
        <h4 className="modal-header p-2 fw-semibold ">{headingText}</h4>

        <div className="modal-body p-3">
          <div className="row">
            {/* Status Field */}
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="address">
                  Status <span className="text-danger">*</span>
                </label>
                <select
                  className={`Floating label select example ${errors.popstatus ? "input-error" : ""}`}
                  value={popstatus}
                  onChange={(e) => {
                    setPopstatus(e.target.value);
                    if (errors.popstatus)
                      setErrors({ ...errors, popstatus: "" });
                  }}
                >
                  <option value="Pending">Pending</option>
                  <option value="Completed">Completed</option>
                </select>
                {errors.popstatus && (
                  <small className="formError">{errors.popstatus}</small>
                )}
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="assignedto">Assigned To</label>

                <div style={{ position: "relative", width: "100%" }}>
                  <input
                    type="text"
                    className="form-control"
                    value={assto}
                    disabled={isAssignedDisabled}
                    onChange={(e) => setAssto(e.target.value)}
                    style={{ paddingRight: "35px" }}
                  />

                  {isAssignedDisabled && (
                    <i
                      className="fa fa-pencil"
                      onClick={() => setIsAssignedDisabled(false)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "black",
                      }}
                    />
                  )}
                </div>
              </div>
            </div>

            {/* Date Field */}

            {/* Completed By Field */}
            <div className="col-md-6 mt-3">
              <div className="form-group">
                <label htmlFor="address">
                  Completed By <span className="text-danger">*</span>
                </label>
                <textarea
                  className={`form-control custom_toolbar_control action-box ${errors.comby ? "input-error" : ""}`}
                  placeholder="Completed By"
                  value={comby}
                  onChange={(e) => {
                    setComby(e.target.value);
                    if (errors.comby) setErrors({ ...errors, comby: "" });
                  }}
                  rows={1}
                />
                {errors.comby && (
                  <small className="formError">{errors.comby}</small>
                )}
              </div>
            </div>
            <div className="col-md-6 mt-3">
              <div className="form-group">
                <label htmlFor="address">
                  Completed On <span className="text-danger">*</span>
                </label>
                {/* <input
                  type="date"
                  className={`form-control custom_toolbar_control ${errors.selectedDate ? "input-error" : ""}`}
                  value={selectedDate}
                  onChange={(e) => {
                    setSelectedDate(e.target.value);
                    if (errors.selectedDate)
                      setErrors({ ...errors, selectedDate: "" });
                  }}
                /> */}
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => {
                    setSelectedDate(date);
                    if (errors.selectedDate)
                      setErrors({ ...errors, selectedDate: "" });
                  }}
                  dateFormat="MM-dd-yyyy"
                  placeholderText="Completed On"
                  customInput={<CalendarInput />}
                  className={`form-control custom_toolbar_control ${
                    errors.selectedDate ? "input-error" : ""
                  }`}
                  isClearable
                />
                {errors.selectedDate && (
                  <small className="formError">{errors.selectedDate}</small>
                )}
              </div>
            </div>
            {/* Comments */}
            <div className="col-md mt-3">
              <h6>Additional Comments </h6>
              <textarea
                className="form-control action-box"
                placeholder="Write any comments"
                value={popcom}
                onChange={(e) => setPopcom(e.target.value)}
              />
            </div>
          </div>

          <div className="row mt-3">
            <div className="card-body action_btns d-flex justify-content-end gap-3 flex-wrap">
              <button
                type="button"
                className="btn btn-secondary fw-bold"
                onClick={onCancel}
              >
                {cancelText}
              </button>
              <button
                type="button"
                className="btn btn-primary fw-bold"
                onClick={updateActionitems}
                disabled={loading}
              >
                {loading ? "Updating..." : submitText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateActionPopUp;
